export default "__VITE_ASSET__1a5643f0__"